const layout = {
  selected: null,
  menuOpen: false,
  menu: [
    {
      id: "/",
      label: "Início",
      icon: "icon-eye",
      permission: "",
      sub: [],
    },
    {
      id: "/novo-processo",
      label: "Novo Processo",
      icon: "icon-add-document",
      permission: "processo:novo_processo:cadastrar",
      sub: [],
    },
    {
      id: "/opiniao-especializada",
      label: "Segunda Opinião",
      icon: "icon-doctor",
      permission: "menu:segunda_opiniao:visualizar",
      sub: [],
    },
    {
      id: "/consenso-pre",
      label: "Consenso Pré",
      icon: "icon-handshake",
      permission: "menu:consenso_pre:visualizar",
      sub: [],
    },
    {
      id: "/junta-medica",
      label: "Junta Médica ou Odontológica",
      icon: "icon-users-alt",
      permission: "menu:junta_medica:visualizar",
      sub: [],
    },
    {
      id: "/relatorios",
      label: "Gestão de processos",
      icon: "icon-chart",
      permission: "bi:relatorios:visualizar",
      sub: [
        {
          id: "/relatorios/bi",
          label: "Business Intelligence",
          icon: "icon-power-bi",
          permission: "bi:powerbi:visualizar",
        },
        {
          id: "/relatorios/desempenho-operacional",
          label: "Desempenho Operacional",
          icon: "icon-chart",
          permission: "bi:relatorio_desempenho:visualizar",
        },
        {
          id: "/relatorios/total-economizado",
          label: "Relatório Gerencial",
          icon: "icon-economy",
          permission: "bi:relatorio_economia:visualizar",
        },
        {
          id: "/relatorios/financeiro",
          label: "Relatório Financeiro",
          icon: "icon-dollar",
          permission: "bi:relatorio_financeiro:visualizar",
          //Gabriela pode ver
          exceptionForUserId: 9,
        },
      ],
    },
    {
      id: "/usuario",
      label: "Usuários",
      icon: "icon-users",
      permission: "admin:usuarios:listar",
      sub: [
        {
          id: "/usuarios/especialistas",
          label: "Especialistas",
          icon: "icon-stetoscope",
          permission: "admin:usuarios_especialistas:listar",
        },
        {
          id: "/usuarios/operadoras",
          label: "Operadoras",
          icon: "icon-building",
          permission: "admin:usuarios_operadoras:listar",
        },
        {
          id: "/usuarios/saasto",
          label: "Saasto",
          icon: "icon-users",
          permission: "admin:usuarios_saasto:listar",
        }
      ],
    },
    {
      id: "/administracoes",
      label: "Administração",
      icon: "icon-settings",
      permission: "admin:administracao:listar",
      sub: [
        {
          id: "/administracao/operadoras",
          label: "Operadoras",
          icon: "icon-building",
          permission: "admin:operadoras:listar",
        },
        {
          id: "/administracao/procedimentos",
          label: "Procedimentos",
          icon: "icon-hand",
          permission: "admin:procedimentos:listar",
        },
        {
          id: "/administracao/materiais",
          label: "Materiais",
          icon: "icon-pills",
          permission: "admin:materiais:listar",
        },
        {
          id: "/administracao/log",
          label: "Logs de Sistema",
          icon: "icon-document",
          permission: "admin:log:listar",
        },
      ],
    },
    {
      id: "/suporte",
      label: "Suporte",
      icon: "icon-comments-question",
      permission: "",
      sub: [],
    },
  ],
  setMenuOpen(open) {
    this.menuOpen = !!open;
  },

  selectRoute(url, sub = false) {
    this.selected = url;
    if (url.startsWith("/relatorios/")) this.openRelatorios = sub;
    if (url.startsWith("/administracoes/")) this.openAdministracao = sub;
    if (url.startsWith("/usuario/")) this.openUsuarios = sub;
  },

  getLabel(lista = [], id, identificador = "id", nome = "nome") {
    return (lista.find((l) => String(l?.[identificador]) === String(id))?.[nome] || id);
  },

  title(name) {
    switch (name) {
      case "junta-medica": return "Junta Médica ou Odontológica";
      case "consenso-pre": return "Consenso Pré";
      case "opiniao-especializada": return "Segunda Opinião";
      default: return "Título da página";
    }
  },
};

export default layout;
